export default {
  account: null,
  login: {
    loading: false,
    error: null,
  },
  user: {},
  userIntrospect: {},
  userChanged: {},
  register: {
    loading: false,
    error: null,
  },
  forgotPassword: {
    loading: false,
    error: null,
  },
  resetPassword: {
    loading: false,
    error: null,
  },
};
